module.exports = __webpack_public_path__ + "75e022067313b6f8e977d960b0e2c070.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-24.png
// module id = 2602
// module chunks = 0